import { injectToolCSS } from "../utils/cssGenerator";

export const superFocusConfig = {
    id: 'super-focus',
    enable: false,
    css: `
        .asw-super-focus-highlight {
            position: fixed;
            pointer-events: none;
            z-index: 10000000;
            border: 4px solid #FF9800;
            border-radius: 4px;
            box-shadow: 0 0 0 4px rgba(255, 152, 0, 0.4);
            transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            opacity: 0;
            display: none;
            animation: asw-pulse-focus 1.5s infinite;
        }

        .asw-super-focus-highlight.active {
            opacity: 1;
            display: block;
        }

        @keyframes asw-pulse-focus {
            0% { box-shadow: 0 0 0 0px rgba(255, 152, 0, 0.7); }
            70% { box-shadow: 0 0 0 10px rgba(255, 152, 0, 0); }
            100% { box-shadow: 0 0 0 0px rgba(255, 152, 0, 0); }
        }
    `
};

export default function superFocus(enable = false) {
    let highlight = document.querySelector('.asw-super-focus-highlight') as HTMLElement;

    injectToolCSS({
        ...superFocusConfig,
        enable
    });

    if (enable) {
        if (!highlight) {
            highlight = document.createElement('div');
            highlight.className = 'asw-super-focus-highlight';
            document.body.appendChild(highlight);
        }

        (window as any).__asw__onFocusInSuperFocus = (event: FocusEvent) => {
            const target = event.target as HTMLElement;

            // Ignore if focus is on the widget itself or hidden elements
            if (target.closest('.asw-widget') || target.closest('.asw-menu')) {
                highlight.classList.remove('active');
                return;
            }

            const rect = target.getBoundingClientRect();
            
            // Add a bit of padding to the highlight
            const padding = 4;
            
            highlight.style.width = `${rect.width + (padding * 2)}px`;
            highlight.style.height = `${rect.height + (padding * 2)}px`;
            highlight.style.top = `${rect.top - padding}px`;
            highlight.style.left = `${rect.left - padding}px`;
            
            highlight.classList.add('active');
        };

        (window as any).__asw__onFocusOutSuperFocus = () => {
             // We can wait a tiny bit to see if focus moves to another valid element
             // or just hide it until next focusin
             highlight.classList.remove('active');
        };

        document.addEventListener('focusin', (window as any).__asw__onFocusInSuperFocus, true);
        document.addEventListener('focusout', (window as any).__asw__onFocusOutSuperFocus, true);
    } else {
        if (highlight) {
            highlight.remove();
        }

        if ((window as any).__asw__onFocusInSuperFocus) {
            document.removeEventListener('focusin', (window as any).__asw__onFocusInSuperFocus, true);
            document.removeEventListener('focusout', (window as any).__asw__onFocusOutSuperFocus, true);
            delete (window as any).__asw__onFocusInSuperFocus;
            delete (window as any).__asw__onFocusOutSuperFocus;
        }
    }
}
